/**
 * Channel store slice (RTK). Same state shape as reducer-ChannelStore.
 */
import { createSlice } from "@reduxjs/toolkit";
import { PROGRESS_STATUS } from "../../constants/metaData";
import { getPayloadValue } from "../../../functions/reduxMethod";

const initialState = {
  "@odata.context": null,
  channelConfigLoad: PROGRESS_STATUS.onStart,
  channelObjectList: [],
  environmentName: "",
  userEmail: "",
  /** Set from api/get-channel-configs when Teams channel Graph description is empty. */
  channelDescriptionMissing: false,
  channelUpdateStatus: PROGRESS_STATUS.onStart,
  /** User dismissed the "missing IFS connection" banner (MainLayout MessageBar). */
  channelConnectionWarningDismissed: false,
  /** True when the current channel is the team's primary (General) channel. */
  isPrimaryChannel: false,
};

const channelSlice = createSlice({
  name: "channelStore",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("ON_CHANNEL_CONFIG_LOAD", (state, action) => {
        state.channelConfigLoad = getPayloadValue(
          action.payload,
          PROGRESS_STATUS.onStart
        );
      })
      .addCase("ON_CHANNEL_OBJECT_CHANGE", (state, action) => {
        const payload = action.payload;
        if (payload && Array.isArray(payload)) {
          state.channelObjectList = getPayloadValue(payload, []);
        } else if (payload && typeof payload === "object") {
          state.channelObjectList = getPayloadValue(payload.channelObjects, []);
          state.environmentName = payload.environmentName || "";
          state.userEmail = payload.userEmail || "";
          if (typeof payload.channelDescriptionMissing === "boolean") {
            state.channelDescriptionMissing = payload.channelDescriptionMissing;
          }
        }
      })
      .addCase("ON_CHANNEL_DESCRIPTION_UPDATE", (state, action) => {
        state.channelUpdateStatus = getPayloadValue(
          action.payload,
          PROGRESS_STATUS.onStart
        );
      })
      .addCase("ON_CHANNEL_CONNECTION_WARNING_DISMISS", (state) => {
        state.channelConnectionWarningDismissed = true;
      })
      .addCase("ON_CHANNEL_CONNECTION_WARNING_RESET", (state) => {
        state.channelConnectionWarningDismissed = false;
      })
      .addCase("ON_IS_PRIMARY_CHANNEL", (state, action) => {
        const { isPrimaryChannel } = action.payload || {};
        state.isPrimaryChannel = isPrimaryChannel === true;
      });
  },
});

export default channelSlice;
